import { useEffect, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { IndividualsPanel } from '@src/components/IndividualsPanel/IndividualsPanel'
import { Footer } from '@src/components/Footer/Footer'
import { PersonalAccount } from '@src/components/PersonalAccaunt/PersonalAccount'
import { Notification } from '@src/components/Notification/Notification'
import { InfoProfileBlock } from '@src/components/InfoProfileBlock/InfoProfileBlock'
import { Button } from '@src/components/Button/Button'
import style from '@src/pages/MyProfile/ProfilePage.module.scss'
import { selectUserCurrentAddresses, selectUserInfo, selectUserServices } from '@src/store/ducks/user/selectors'
import { email, phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { logout } from '@src/store/ducks/auth/thunks'
import { ReactComponent as Exit } from '@src/images/exit.svg'
import { AppDispatch } from '@src/store/store'
import { setPageTitle } from '@src/store/ducks/app/reducer'
import { ProfileField } from '@src/components/ProfileField/ProfileField'
import { PersonalDataBlock } from '@src/components/InfoProfileBlock/PersonalDataBlock'

const validationSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegexp, validateForm.phone)
    .required(validateForm.required),
  phones: Yup.array().of(
    Yup.string().matches(phoneRegexp, validateForm.phone)
      .required(validateForm.required),
  ),
  email: Yup.string()
    .matches(email, validateForm.email)
    .required(validateForm.required),
})

export const ProfilePage = () => {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector(selectUserInfo)
  const currentAddresses = useSelector(selectUserCurrentAddresses)
  const { tariff } = useSelector(selectUserServices)

  useEffect(() => { dispatch(setPageTitle('Мой профиль |Личный кабинет для абонентов КОСМОС Телеком')) }, [dispatch])

  const initialValues = useMemo(() => {
    const data: any = {
      address: !!tariff.length && tariff[0].address,
      emails: user.emails,
      phoneNotify: user.phoneNotify,
      phones: user.phones,
      userName: user.username,
    }

    if (user.isSubscriber) {
      user.fields.forEach((el: any) => {
        data[el.name] = el.field?.value || ''
      })
    }

    return data
  }, [tariff, user])

  return (
    <div>
      <IndividualsPanel />
      <div className={cn('container', style.boxProfile)}>
        <div className={style.profileContainer}>
          <PersonalAccount />
          <div className={style.myProfile}>
            <h2>Мой профиль</h2>
            <div className={style.dataProfile}>
              <div className={style.headingBlock}>
                <div className={style.headingTitle}>{user.username}</div>
                <div className={style.headingDescription}>
                  Договор №
                  {currentAddresses && currentAddresses.account}
                </div>
              </div>
              <Formik<typeof initialValues>
                initialValues={initialValues}
                onSubmit={() => {}}
                validationSchema={validationSchema}
                enableReinitialize
              >
                {({ values }) => (
                  <>
                    {!user.isSubscriber && (
                      <InfoProfileBlock
                        title="Адрес подключения"
                        className={style.item}
                        name="address"
                      />
                    )}

                    <InfoProfileBlock
                      title="Контактный телефон"
                      className={style.item}
                      name="phones"
                    />

                    {!!values.emails.length && (
                      <InfoProfileBlock
                        title="Email"
                        className={style.item}
                        name="emails"
                      />
                    )}

                    {user.isSubscriber && (
                      <>
                        {user.fields
                          .filter((el: any) => {
                            const name = el.name?.toLowerCase() || ''
                            const placeholder = el.placeholder?.toLowerCase() || ''
                            if (name.includes('дата рождения') || placeholder.includes('дата рождения')) return false
                            if (name.includes('адрес') || placeholder.includes('адрес')) return false
                            return true
                          })
                          .map((el: any) => (
                            <ProfileField
                              key={el.id}
                              placeholder={el.placeholder}
                              name={el.name}
                              fieldId={el.id}
                            />
                          ))}
                      </>
                    )}
                  </>
                )}
              </Formik>
              <PersonalDataBlock className={style.item} />
            </div>
            <Notification newClass={style.newStyleNotification} />
            <div className={style.actions}>
              <div className={style.btnBlock}>
                {!user.isSubscriber && (
                  <NavLink
                    to="/change-password"
                  >
                    <Button type="textSecondary" className={style.btn}>Сменить пароль</Button>
                  </NavLink>
                )}

                {!user.isSubscriber
                  ? (
                    <NavLink to="/termination-agreement">
                      <Button type="textSecondary" className={style.btn}>
                        Расторгнуть договор
                      </Button>
                    </NavLink>
                  ) : (
                    <Button type="text" className={style.btn}>
                      Выйти из аккаунта
                    </Button>
                  )}
              </div>
              <button type="button" onClick={() => { dispatch(logout()) }} className={style.logout}>
                <Exit />
                Выйти из аккаунта
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
